import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Spin } from 'antd'
import {withTranslation} from 'react-i18next'
import ShortLinkSearchResult from './ShortLinkSearchResult'
@inject('marketingSmsManagementStore', 'marketingShortLinkStore')
@observer
class FormModal extends Component {
  state = {
  }
  formRef = React.createRef()
  componentDidMount() {
  }
  render() {
    const { marketingShortLinkStore, addModalVisible, handleCancel, onChangeInsertShortLink, type, t } = this.props
    const { isFetching } = marketingShortLinkStore
    return (
      <>
        <Modal
          title='插入短链接'
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={false}
          className='shortLinkModel'
        >
          <Spin spinning={isFetching}>
            <ShortLinkSearchResult type={type} handleCancel={handleCancel} onChangeInsertShortLink={onChangeInsertShortLink} />
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
